import * as angular from 'angular';
import template from "./vertical-trend.tpl.html";

export default angular
	.module('aps.directives.vertTrend', [])
	.directive('vertTrend', () => {
		return {
			replace: true,
			scope: {
				trend: '=trend'
			},
			template: template,
		};
	})
	.name;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/app/directives/vertical-trend.ts